import { render } from "./Permissions.vue?vue&type=template&id=396fe7e4&scoped=true"
import script from "./Permissions.vue?vue&type=script&lang=js"
export * from "./Permissions.vue?vue&type=script&lang=js"

import "./Permissions.vue?vue&type=style&index=0&id=396fe7e4&scoped=true&lang=css"

import exportComponent from "/home/lyonjo5/lyon-marketing-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396fe7e4"]])

export default __exports__